import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Hero from './components/Hero';
import Categories from './components/Categories';
import Highlights from './components/Highlights';
import Services from './components/Services';
import Testimonials from './components/Testimonials';
import FAQ from './components/FAQ';
import CTA from './components/CTA';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <Categories />
        <Highlights />
        <Services />
        <Testimonials />
        <FAQ />
        <CTA />
      </main>
      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebSite',
            name: '精品八区',
            alternateName: '精品八区官网',
            url: 'https://www.jingpin8qu.com/',
            description:
              '精品八区，汇聚高端精选资源与优质生活体验。提供精品居住、优质服务、专属会员权益一站式尊享解决方案。',
            inLanguage: 'zh-CN',
            potentialAction: {
              '@type': 'SearchAction',
              target: 'https://www.jingpin8qu.com/search?q={search_term_string}',
              'query-input': 'required name=search_term_string',
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Organization',
            name: '精品八区',
            url: 'https://www.jingpin8qu.com/',
            description:
              '高端精选生活社区，汇聚精品居住、优质服务与专属会员权益。',
            address: {
              '@type': 'PostalAddress',
              addressCountry: 'CN',
              addressRegion: '北京',
              addressLocality: '北京市',
            },
            contactPoint: {
              '@type': 'ContactPoint',
              contactType: 'customer service',
              availableLanguage: ['Chinese'],
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: [
              {
                '@type': 'Question',
                name: '如何成为精品八区会员？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '成为精品八区会员需要通过申请与审核流程。您可以访问我们的官网提交入会申请表，我们的会员服务团队将在3个工作日内与您联系，安排一对一咨询。审核通过后，您需要缴纳相应的会员年费，即可享受精品八区的全部会员权益。',
                },
              },
              {
                '@type': 'Question',
                name: '精品八区会员年费是多少？包含哪些权益？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '精品八区提供银卡、金卡和钻石卡三个会员等级，年费从8.8万元至38.8万元不等。基础权益包括：管家服务、社区活动参与、共享空间使用权、专属礼遇等。',
                },
              },
              {
                '@type': 'Question',
                name: '精品八区的社区覆盖哪些城市？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '目前精品八区已在北京、上海、深圳、杭州、成都五个城市设立了精品社区，并在三亚、厦门、昆明设有度假型物业。',
                },
              },
            ],
          }),
        }}
      />
    </>
  );
}